export default "__VITE_ASSET__Dn$W71iy__"